const getKey = ({ key }: { key: string }) => `${key}`;

export default getKey;
